module.exports = __webpack_public_path__ + "static/sprite-9905ce762941a0f6d2fd250cb3b28fb5.svg";